// @flow
import React from 'react';
import { get, map } from 'lodash';
import { connect } from 'react-redux';
import { ServiceTemplatesList as ServiceTemplatesListView } from '@views';
import { serviceTemplateActions } from '@context/serviceTemplates';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import type { Dispatch, User, DoctorsState, ServicesState, BundledPermissions } from '@types';
import { sort, alphabeticCompare } from '@helpers/helpers';
import { mapBundledPermission, canEditDoctor, mapManagesClinic } from '@helpers/connect';
import { logout } from '@context/user';

type Props = {
  dispatch: Function,
  doctorId: number,
  doctors: DoctorsState,
  user: User,
  services: ServicesState,
  permissions: BundledPermissions,
  history: Object,
  isManager: boolean,
  isSecretary: boolean,
  canEditDoctorServices: boolean,
  singleDoctor: boolean,
  t: Function,
};

class ServiceTemplatesList extends React.Component<Props> {
  componentWillMount() {
    const { doctorId, dispatch } = this.props;
    dispatch(serviceTemplateActions.getServiceTemplates(doctorId));
  }

  componentWillReceiveProps(next: Props) {
    const { doctorId, dispatch } = next;
    if (this.props.doctorId !== doctorId) {
      dispatch(serviceTemplateActions.getServiceTemplates(doctorId));
    }
  }

  render() {
    const {
      services, doctors, user, doctorId, permissions, isManager, isSecretary, canEditDoctorServices, singleDoctor,
    } = this.props;

    const doctorsList = map(get(doctors, 'data', {}), (doctor: any) => ({
      text: doctor.nameWithTitle,
      name: doctor.name,
      urlTo: `/ajustes/servicos/${doctor.id}`,
      ...doctor,
    }));

    // The API's rules: shared services are the managers'; a doctor's, the doctor's, the secretaries' and the managers'
    const canEditShared = isManager;

    const sharedItems = [];
    const doctorItems = [];
    map(get(services, 'data', {}), (service) => {
      if (!service || !service.id) return;
      const editable = service.shared ? canEditShared : canEditDoctorServices;
      const item = {
        ...(editable ? { linkTo: `/ajustes/servicos/${doctorId}/${service.id}` } : { preventClick: true }),
        customRendererData: {
          name: service.name,
          price: service.price,
          unit: service.unit,
          healthInsurance: Boolean(service.healthInsurance),
        },
      };
      (service.shared ? sharedItems : doctorItems).push(item);
    });

    return (
      <ServiceTemplatesListView
        doctorId={doctorId}
        user={user}
        doctorsData={doctors}
        doctorsList={sort(doctorsList, alphabeticCompare(['name']))}
        sharedItems={sharedItems}
        doctorItems={doctorItems}
        servicesLoading={get(services, 'isLoading')}
        isFeatureEnabled={permissions.planInclude.financial}
        onLogout={this.handleLogout}
        permissions={permissions}
        canEditShared={canEditShared}
        canEditDoctor={canEditDoctorServices}
        canPickDoctor={!singleDoctor && (isManager || isSecretary)}
        pushPath={this.handlePushPath}
        onPrint={this.handlePrint}
      />
    );
  }

  handleLogout = () => this.props.dispatch(logout());

  handlePrint = () => {
    const { dispatch, doctorId, t } = this.props;
    dispatch(serviceTemplateActions.printServiceTemplates(doctorId, t('settings:action/menu/sevices_list')));
  };

  handlePushPath = (url: string) => {
    this.props.history.push(url);
  };
}

const mapStateToProps = (state, ownProps) => ({
  services: state.context.serviceTemplates,
  doctors: state.context.doctors,
  user: state.context.user,
  doctorId: get(ownProps, ['match', 'params', 'doctorId']),
  permissions: mapBundledPermission(state),
  isManager: mapManagesClinic(state),
  isSecretary: get(state, ['context', 'user', 'roleType']) === 'Secretary',
  canEditDoctorServices: canEditDoctor(state, get(ownProps, ['match', 'params', 'doctorId'])),
  singleDoctor: get(state, ['context', 'clinics', 'activeClinic', 'doctorIds'], []).length <= 1,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({ dispatch });

export default withTranslation()(withRouter(connect<any, any, any, any, any, any>(
  mapStateToProps,
  mapDispatchToProps,
)(ServiceTemplatesList)));
